import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class ClientService {
  static async getAllClients (query = {}) {
    const { data } = await axios.get(`${url}/client`, {
      headers,
      params: query
    })

    return data?.data
  }

  static async getClientByRFC (rfc) {
    const { data } = await axios.get(`${url}/client/${rfc}`, { headers })
    return data?.data
  }

  static async addPaymentReference (info) {
    const { data } = await axios.post(`${url}/client/addPaymentReference/`, info, { headers })
    return data
  }

  static async getPaymentReferences (payload) {
    const { data } = await axios.get(`${url}/client/getPaymentReferences/${payload.clientId}`, { headers, params: payload })
    return data
  }

  static async getPaymentReferenceByID (params) {
    const { data } = await axios.get(`${url}/client/getPaymentReferenceByID/${params.referenceId}`, { headers, params })
    return data
  }

  static async hasPilotAccess (clientId) {
    const { data } = await axios.get(`${url}/client/${clientId}/access/pilot-group`, { headers })
    return data
  }
}
